// Ztove cart enhancements — upsell ATC + shipping-bar live updates.
(function () {
  const moneyFormat = (() => {
    const el = document.getElementById('ztove-product-drawer');
    return (el && el.dataset.moneyFormat) || window.Shopify?.money_format || '{{ amount }} DKK';
  })();

  function formatMoney(cents) {
    const amount = (Math.max(0, cents) / 100).toFixed(2);
    const [intPart, decPart] = amount.split('.');
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const formatted = decPart === '00' ? withThousands : `${withThousands},${decPart}`;
    return moneyFormat
      .replace(/{{\s*amount\s*}}/g, formatted.replace('.', ','))
      .replace(/{{\s*amount_no_decimals\s*}}/g, withThousands)
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, formatted)
      .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/g, withThousands);
  }

  function updateShipBar(totalCents) {
    const bar = document.querySelector('[data-ztove-ship]');
    if (!bar) return;
    const threshold = Number(bar.dataset.threshold || 0);
    if (!threshold) {
      bar.setAttribute('data-qualifies', 'true');
      const fill = bar.querySelector('[data-ztove-ship-fill]');
      if (fill) fill.style.setProperty('--progress', '100%');
      return;
    }
    const qualifies = totalCents >= threshold;
    bar.setAttribute('data-qualifies', qualifies ? 'true' : 'false');
    const progress = Math.min(100, Math.max(0, (totalCents / threshold) * 100));
    const fill = bar.querySelector('[data-ztove-ship-fill]');
    if (fill) fill.style.setProperty('--progress', `${progress}%`);
    const remainingEl = bar.querySelector('[data-ztove-ship-remaining]');
    if (remainingEl && !qualifies) {
      remainingEl.textContent = formatMoney(Math.max(0, threshold - totalCents));
    }
  }

  function parseIsoDate(value) {
    if (!value || typeof value !== 'string') return null;
    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const [, year, month, day] = match;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatDeliveryDate(value) {
    const date = parseIsoDate(value);
    if (!date) return value || '';

    const locale = document.documentElement.lang || 'en-US';
    try {
      return date.toLocaleDateString(locale, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      });
    } catch (_) {
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      });
    }
  }

  function getPropertyValue(properties, matcher) {
    if (!properties) return '';

    if (Array.isArray(properties)) {
      const entry = properties.find(([key, value]) => matcher(String(key).toLowerCase()) && value);
      return entry ? String(entry[1]) : '';
    }

    if (typeof properties === 'object') {
      const key = Object.keys(properties).find((propertyKey) => matcher(propertyKey.toLowerCase()) && properties[propertyKey]);
      return key ? String(properties[key]) : '';
    }

    return '';
  }

  function getDeliveryValue(cart) {
    if (!cart?.items) return '';

    for (const item of cart.items) {
      const date = getPropertyValue(
        item.properties,
        (key) => key === 'delivery date' || key === 'delivery_date' || key.includes('delivery date')
      );
      if (date) return formatDeliveryDate(date);

      const mode = getPropertyValue(item.properties, (key) => key === 'delivery');
      if (mode) return mode;
    }

    return '';
  }

  function updateDelivery(cart) {
    const wrap = document.querySelector('[data-ztove-delivery]');
    if (!wrap) return;

    const valueEl = wrap.querySelector('[data-ztove-delivery-value]');
    if (!valueEl) return;

    const currentValue = valueEl.textContent.trim();
    const deliveryValue = getDeliveryValue(cart) || formatDeliveryDate(currentValue) || wrap.dataset.fallback || '';
    if (!deliveryValue) {
      wrap.hidden = true;
      return;
    }

    valueEl.textContent = deliveryValue;
    wrap.hidden = false;
  }

  async function fetchCart() {
    try {
      const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      return cartRes.ok ? await cartRes.json() : null;
    } catch (_) {
      return null;
    }
  }

  async function refreshDeliveryFromCart() {
    const cart = await fetchCart();
    if (cart) updateDelivery(cart);
  }

  function scheduleDeliveryRefresh() {
    window.setTimeout(refreshDeliveryFromCart, 0);
    window.setTimeout(refreshDeliveryFromCart, 120);
  }

  async function addUpsell(wrap) {
    const variantId = wrap.dataset.variantId;
    if (!variantId) return;
    const btn = wrap.querySelector('[data-atc-button]');
    const stepper = wrap.querySelector('[data-qty-stepper]');
    const valueEl = wrap.querySelector('[data-qty-value]');
    if (btn) btn.classList.add('is-loading');

    // Collect section ids so the cart drawer re-renders.
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    try {
      const payload = { id: Number(variantId), quantity: 1 };
      if (sectionIds.length) payload.sections = sectionIds.join(',');

      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || 'Add failed');
      const addResponse = await res.json();

      let cart;
      try {
        const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        if (cartRes.ok) cart = await cartRes.json();
      } catch (_) {
        /* ignore */
      }

      if (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
      }
      if (stepper && valueEl) {
        valueEl.textContent = '1';
        stepper.hidden = false;
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'ztove-cart-upsell',
            data: {
              source: 'ztove-cart-upsell',
              sections: addResponse?.sections,
              itemCount: cart?.item_count,
              variantId: String(variantId),
            },
          },
        })
      );

      if (cart) updateShipBar(cart.total_price);
      if (cart) updateDelivery(cart);
    } catch (err) {
      console.error('[ztove-cart-upsell]', err);
      if (btn) btn.classList.remove('is-loading');
    }
  }

  async function changeUpsell(wrap, delta) {
    const variantId = Number(wrap.dataset.variantId);
    if (!variantId) return;
    const stepper = wrap.querySelector('[data-qty-stepper]');
    const valueEl = wrap.querySelector('[data-qty-value]');

    try {
      const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      const cart = await cartRes.json();
      const item = cart.items.find((i) => i.variant_id === variantId);
      const newQty = Math.max(0, (item?.quantity || 0) + delta);

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      const payload = { id: variantId, quantity: newQty };
      if (sectionIds.length) payload.sections = sectionIds.join(',');

      const changeRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const changeJson = await changeRes.json();

      if (valueEl) valueEl.textContent = String(newQty);
      if (newQty === 0 && stepper) stepper.hidden = true;

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: changeJson,
            sourceId: 'ztove-cart-upsell',
            data: {
              source: 'ztove-cart-upsell',
              sections: changeJson?.sections,
              itemCount: changeJson?.item_count,
              variantId: String(variantId),
            },
          },
        })
      );

      updateShipBar(changeJson.total_price);
      updateDelivery(changeJson);
    } catch (err) {
      console.error('[ztove-cart-upsell]', err);
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const wrap = event.target.closest('[data-ztove-cart-upsell]');
    if (!wrap) return;
    const atcBtn = event.target.closest('[data-atc-button]');
    const incBtn = event.target.closest('[data-qty-increase]');
    const decBtn = event.target.closest('[data-qty-decrease]');
    if (atcBtn) {
      event.preventDefault();
      addUpsell(wrap);
    } else if (incBtn) {
      event.preventDefault();
      changeUpsell(wrap, 1);
    } else if (decBtn) {
      event.preventDefault();
      changeUpsell(wrap, -1);
    }
  });

  document.addEventListener('cart:update', (event) => {
    const resource = event.detail?.resource;
    if (resource && typeof resource.total_price === 'number') {
      updateShipBar(resource.total_price);
      updateDelivery(resource);
    }
    scheduleDeliveryRefresh();
  });

  customElements.whenDefined('cart-drawer-component').then(() => {
    document.querySelectorAll('cart-drawer-component').forEach((drawer) => {
      drawer.addEventListener('dialog:open', scheduleDeliveryRefresh);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateDelivery();
      scheduleDeliveryRefresh();
    });
  } else {
    updateDelivery();
    scheduleDeliveryRefresh();
  }
})();
